module.exports = __webpack_public_path__ + "static/jdcravensII-66b724b9eee305c41ec87e13964160ff.png";